define('views/shared/footer/footer_column',[
    'backbone',
    'text!views/shared/footer/footer_column.html',
    'views/_base/baseview'
], function(Backbone, Template, BaseView){
    'use strict';

    return BaseView.extend({
        tagName   : 'div',
        template  : _.template(Template),
        isRender  : true,
        needsAuth : false,
        events    : {
            'click h2 a': 'toggleLinks',
            'click button': 'toggleLinks',
            'click .js-footer-links-btn-quicklinks': 'toggleLinks'
        },
        
        initialize: function(options){
            options = options || {};

            this.column = options.column || {};

            BaseView.prototype.initialize(this);
        },

        render: function(){
            this.$el.addClass(this.column.class).html(this.template());

            this.addLinks();

            return this;
        },

        addLinks: function(){
            var that = this,
                links = this.column.links;

            if(_.isArray(links)){

                links.forEach(function(link){

                    var list_item = document.createElement('li'),
                        list_item_anchor = document.createElement('a');

                    list_item_anchor.className = link.class;
                    list_item_anchor.innerHTML = link.text;

                    if(link.pdf){

                        var url = pf.getContent('global.url.pdf_root');

                        list_item_anchor.href = url + link.pdf;
                        
                    } else {
                        list_item_anchor.href = link.url;
                    }

                    if(link.target){
                        list_item_anchor.target = link.target;
                    }
                    
                    list_item.appendChild(list_item_anchor);

                    that.$('.js-footer-links').append(list_item);

                });

            }

        },

        toggleLinks: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            var footer_column = $(e.currentTarget).parent().parent();
            
            footer_column.find('ul').toggleClass('open');

            footer_column.find('.footer-links-btn').toggleClass('open');
        },

        close: function(){}
    });
});
